module.exports = __webpack_public_path__ + "img/d9dab63.jpg";